import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { LanguageSelector } from '../../../entry-components/lang-selector-wrapper/models/lang-selector-wrapper.interface';
import {
  CountryLanguage,
  FooterAem
} from '../../models/header-footer-mach-core/footer-aem.interfaces';
import {
  CountryLanguages,
  LanguageDetails
} from '../../models/utils/country-language.interfaces';
import { HeaderFooterMachCoreContentService } from '../../services/header-footer-mach-core/header-footer-mach-core-content.service';
import {
  AppConfigService,
  CookieHelperService,
  LoggingService
} from '../../services/utils';
import { CountryLanguageHelper } from '../../utils/country-language/country-language-helper';
import { CountryLanguageService } from '../../utils/country-language/country-language.service';
import { FlyoutLangSelectorFacade } from '../flyout/flyout-lang-selector/flyout-lang-selector.facade';

@Injectable({
  providedIn: 'root'
})
export class LangSelectorExtendedFacade {
  languageSelectorContent$!: Observable<LanguageSelector>;
  countryLanguageContent!: CountryLanguage;
  contentFooter!: FooterAem;
  countryLanguageList!: CountryLanguages[];
  prefLanguage!: LanguageDetails;
  secondaryPrefLanguage!: LanguageDetails;
  prefCookieValue = '';
  langCode = '';
  countryName = '';
  countrySlector = '';

  appConfig = inject(AppConfigService);
  contentService = inject(HeaderFooterMachCoreContentService);
  countryLangSvc = inject(CountryLanguageService);
  countryLanguageHelper = inject(CountryLanguageHelper);
  cookieHelper = inject(CookieHelperService);
  loggingService = inject(LoggingService);
  selectorFacade = inject(FlyoutLangSelectorFacade);

  setPrimaryLanguage(primaryLang: LanguageDetails, res: string[]): void {
    this.prefLanguage = primaryLang;
    const secondaryPreferredLanguage =
      this.countryLanguageHelper.getSecondaryLanguageForSelectedLanguage(
        res[1],
        res[0]
      );
    if (secondaryPreferredLanguage)
      this.secondaryPrefLanguage = secondaryPreferredLanguage;
  }

  setCountryNameWithPrimaryLang(res: string[]): void {
    const country = this.countryLanguageHelper.getCountryForCountryCode(res[1]);
    const primarylang = this.countryLanguageHelper.getLangaugeForLanguageCode(
      res[1],
      res[0]
    );
    if (country && country.countryName) {
      this.countryName = country.countryName;
    }
    if (primarylang) {
      this.setPrimaryLanguage(primarylang, res);
    }
  }
}
